<script>
    import { apiUrl } from "@/utils";
    import { sendAnalytics } from "@/core/SendAnalytics";
    import ProductCardButtons from "@/components/ProductCardButtons";
    import ButtonCompare from "@petoneer/components/ButtonCompare";
    import ProductCardFeatures from "@petoneer/components/ProductCardFeatures";

    export default {
        name: "ProductCard",
        components: { ProductCardFeatures, ButtonCompare, ProductCardButtons },
        props: {
            product: Object,
            position: Number,
            isSearch: Boolean,
            isAvalible: Boolean,
            isSmall: Boolean,
            inCartList: Array,
            isOdd: Boolean,
        },
        data() {
            let isPreOrder = false;
            let currentOffers = this.product.offers.filter((offer) => offer.available);
            if (currentOffers.length === 0) {
                // проверка на предзаказ
                currentOffers = this.product.offers.filter((offer) => !offer.available);
                isPreOrder = true;
            }

            const previewImage =
                currentOffers[0].previewImage?.medium || this.product.previewImage?.medium;

            return {
                currentOffers,
                offer: currentOffers[0],
                offerId: currentOffers[0].id,
                previewImage,
                price: currentOffers[0].price,
                discountPrice: currentOffers[0].discountPrice,
                discountPercent: currentOffers[0].discountPercent,
                inCart: this.product.inCart || false,
                isPreOrder,
                // previewImageFromOffer: "",
            };
        },
        watch: {
            inCartList() {
                this.checkProductInCart();
            },
            offerId() {
                this.checkProductInCart();
            },
        },
        computed: {
            nameProduct() {
                return this.product.shortName ? this.product.shortName : this.product.name;
            },
            isAppSupport() {
                return Object.keys(this.product.labels).length > 0
                    ? Object.keys(this.product.labels).some((name) => name === "workWithApii")
                    : false;
            },
            productPath() {
                return {
                    name: "Product",
                    params: { slug: this.product.slug },
                };
            },
        },
        mounted() {
            this.checkProductInCart();
        },
        methods: {
            apiUrl,
            checkProductInCart() {
                this.inCartList
                    ? (this.inCart = this.inCartList.includes(this.offerId.toString()))
                    : (this.inCart = false);
            },
            sendDataLayerEvent() {
                sendAnalytics.send(sendAnalytics.events.productClick, {
                    name: this.product.name,
                    offerId: this.offerId,
                    price: this.discountPrice,
                    position: this.position,
                });
            },
        },
    };
</script>

<template>
    <div
        class="card"
        :class="{
            'card--in-cart visible': inCart,
            'is-app': isAppSupport,
        }"
    >
        <div v-if="product.canCompared" class="card__compare">
            <button-compare
                class="card__z-top"
                size="md"
                :product-id="product.id"
            ></button-compare>
        </div>

        <div class="card__img">
            <router-link
                :to="productPath"
                class="card__img-link js-lazy-load"
                tabindex="-1"
                @click.native.prevent="sendDataLayerEvent"
            >
                <img
                    :data-src="apiUrl(previewImage)"
                    src="/static/preloader_card.gif"
                    alt=""
                />
            </router-link>
        </div>

        <router-link
            :to="productPath"
            class="card__hover"
            tabindex="-1"
            @click.native.prevent="sendDataLayerEvent"
        ></router-link>

        <div class="card__price card__z-top">
            <div
                class="card__price-num card__price-num--current"
                :class="{
                    'card__price-num--sale': discountPercent,
                    'card__price-num--small': isSmall,
                }"
            >
                {{ discountPrice | formatPrice }}&nbsp;₽
            </div>
            <div
                v-if="discountPercent"
                class="card__price-num card__price-num--old"
                :class="{ 'card__price-num--small-old': isSmall }"
            >
                {{ price | formatPrice }}&nbsp;₽
            </div>
            <div v-if="discountPercent" class="card__labels">
                <div class="card__label card__label--sale">-{{ discountPercent }}%</div>
            </div>
        </div>

        <router-link
            :to="productPath"
            class="card__name card__z-top"
            :class="{ 'card__name--small': isSmall }"
            @click.native.prevent="sendDataLayerEvent"
        >
            {{ nameProduct }}
        </router-link>

        <product-card-features
            :icons="product.labels"
            :list="product.listSpecifications"
            :is-odd="isOdd"
        ></product-card-features>

        <product-card-buttons
            class="card__z-top"
            size-button="md"
            :offer-id="offerId"
            :product="product"
            :is-pre-order="isPreOrder"
            :in-cart="inCart"
            :discount-price="discountPrice"
            initial-text="В корзину"
            @on-added-to-cart="inCart = true"
        >
        </product-card-buttons>
    </div>
</template>

<style lang="scss">
    .card {
        display: flex;
        flex-direction: column;
        position: relative;
        background-color: #fff;
        height: auto;
        padding: 24px 0 0;
        @include bp($bp-tablet-sm) {
            padding: 30px 4px 4px;
        }
        @include bp($bp-desktop-sm) {
            padding: 38px 12px 12px;
        }
        &.swiper-slide {
            height: auto;
        }
        @include bp($bp-desktop-sm-for-card) {
            &:hover,
            &:focus-within {
                .card__hover {
                    opacity: 1;
                }
                .card__name {
                    color: var(--info);
                }
            }
        }
    }
    .card__compare {
        position: absolute;
        top: 4px;
        right: 7px;
    }
    .card__hover {
        position: absolute;
        @include box(100%);
        top: 0;
        left: 0;
        z-index: 3;
        background: rgba(0, 26, 52, 0.03);
        border-radius: 20px;
        opacity: 0;
        transition: 0.25s ease-in-out all;
        outline: none;
    }
    .card__img {
        position: relative;
        z-index: 2;
        margin-bottom: 8px;
    }
    .card__img-link {
        position: relative;
        display: block;
        padding-bottom: 100%;
        outline: none;
        img {
            @include center-absolute(0);
            margin: auto;
            max-height: 100%;
        }
    }
    .card__labels {
        margin-left: 7px;
    }
    .card__label {
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
        border-radius: 4px;
        padding: 2px 6px;
    }
    .card__label--sale {
        background-color: var(--danger--light);
        color: #fff;
    }
    .card__name {
        display: block;
        position: relative;
        z-index: 2;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        color: var(--primary-text);
        margin-bottom: 8px;
        transition: 0.3s ease-in-out color;
        min-height: 32px;
        @include bp($bp-tablet-sm) {
            font-size: 16px;
            line-height: 22px;
            margin-bottom: 16px;
            min-height: 44px;
            padding-right: 10px;
        }
        @include bp($bp-desktop-sm) {
            &:focus-visible {
                outline-offset: -1px;
            }
        }
    }
    .card__name--small {
        font-size: 13px;
        line-height: 18px;
    }
    .card__price {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        margin-bottom: 6px;
        @include bp($bp-tablet-sm) {
            margin-bottom: 10px;
        }
    }
    .card__price-num {
        font-weight: bold;
        font-size: 16px;
        line-height: 16px;
        @include bp($bp-tablet-sm) {
            font-size: 20px;
            line-height: 24px;
        }
    }
    .card__price-num--current {
        margin-right: 7px;
    }
    .card__price-num--old {
        font-size: 12px;
        line-height: 14px;
        font-weight: 500;
        text-decoration: line-through;
        margin-bottom: 2px;
        @include bp($bp-tablet-sm) {
            font-size: 16px;
            line-height: 20px;
            margin-bottom: 3px;
        }
    }
    .card__price-num--sale {
        color: var(--danger--light);
    }
    .card__price-num--small {
        font-size: 16px;
        line-height: 16px;
    }
    .card__price-num--small-old {
        font-size: 12px;
        line-height: 14px;
    }
    .card__z-top {
        position: relative;
        z-index: 4;
    }
    .product-card__controls {
        margin-top: auto;
    }
    .product-card__control-button {
        position: relative;
        z-index: 4;
    }
</style>
